import { Widget, WidgetHeight } from "@arelia-types/widget";
import MyContentSongsContainer from "./songs/MyContentSongsContainer";

export const MY_CONTENT_WIDGETS: Widget[] = [{
  name: "All Songs",
  id: "ALL_SONGS",
  component: MyContentSongsContainer,
  size: 12,
  height: WidgetHeight.L,
  page: "/my-content",
  tab: "/songs",
}];